module.exports = __webpack_public_path__ + "static/media/photo318.ac5c6e2e.jpg";